// extracted by mini-css-extract-plugin
module.exports = {"MainHeader":"MainHeader_MainHeader__2BknJ","Scrolling":"MainHeader_Scrolling__FeW1Q"};